import Store from '@/store';
import { appMixins } from '@/mixins';

export default ({
	run: () => {
		const redirect = appMixins.getParameterFromUrl('redirect');
		if (redirect !== null) {
			Store.dispatch('application/SET_PROPERTY', { redirect });
		}
	},
});
